<template>
  <div class="notes-header-wrapper -pxy_2">
    <div 
      v-if="loading"
      class="text-content-loading mr-4 flex !size-10 items-center justify-center !rounded-full"
    >
      <sword-icon name="profile" class="!text-context-5" />
    </div>
    <profile-picture
      v-else
      class="mr-4"
      size="md"
      :show-vip-icon="vip"
      :show-high-risk-icon="highRisk"
      :picture="picture"
      :gender="gender"
    />
    <span class="t2 -t_medium" :class="{'text-content-loading': loading}"> {{ name }}</span>
    <sword-button-wuk
      class="close-button"
      theme="text"
      round
      size="small"
      icon="close"
      @click.native="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { UserGender } from '@/types/app-data/user.types'

const props = defineProps<{
  picture: string
  vip: boolean
  highRisk: boolean
  gender: UserGender
  name: string
}>()

const loading = computed(() => !props.name)
</script>

<style lang="scss" scoped>

.notes-header-wrapper {
  display: flex;
  align-items: center;
  border-bottom: 1px solid $context-color-6;

  span {
    flex: 1 1 auto;
  }
}

.close-button {
  display: none;

  @media screen and (max-width: break-wuk('medium', 's')) {
    display: block;
  }
}
</style>
